// Sugalarm — /api/settings wrappers (cycle 4 backend; cycle 10 UI).

import { request } from "../lib/apiClient";
import type { ApiResult, UserSettings, UserSettingsPatch } from "../lib/types";

export function get(): Promise<ApiResult<UserSettings>> {
  return request<UserSettings>("/api/settings");
}

export function patch(body: UserSettingsPatch): Promise<ApiResult<UserSettings>> {
  return request<UserSettings>("/api/settings", { method: "PATCH", body });
}

export function reset(): Promise<ApiResult<UserSettings>> {
  return request<UserSettings>("/api/settings/reset", { method: "POST" });
}
